<template>
  <path
    d="M18.29 15.7102L13.71 20.2902C13.32 20.6802 12.68 20.6802 12.29 20.2902C11.9 19.9002 11.9 19.2602 12.29 18.8702L15.17 16.0002H5C4.45 16.0002 4 15.5502 4 15.0002V5.00024C4 4.45024 4.45 4.00024 5 4.00024C5.55 4.00024 6 4.45024 6 5.00024V14.0002H15.17L12.29 11.1302C11.9 10.7402 11.9 10.1002 12.29 9.71024C12.68 9.32024 13.32 9.32024 13.71 9.71024L18.29 14.2902C18.68 14.6802 18.68 15.3202 18.29 15.7102Z"
  />
</template>
